export default __webpack_public_path__ + "static/media/No schedule message.2439e542.svg";